/**
 * Where readers are pointed when the archive itself is at fault. The site is
 * served under more than one brand's domain, so the address follows the host.
 */
export const SUPPORT_EMAIL = window.location.hostname.includes('statara')
  ? 'support@statara.com'
  : 'support@targetsmart.com'
